import React, { useEffect, useState } from "react";

const TestimonialItem = ({ colSize, itemShow, testimonialData, layoutStyle }) => {
  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, index) => (
      <span 
        key={index} 
        className={`star ${index < rating ? 'star-filled' : 'star-empty'}`}
      >
        ★
      </span>
    ));
  };
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {testimonialData.slice(0, itemShow).map((data, index) => (
        <div className={`${colSize}`} key={index}>
          <div className={`testimonial-grid ${layoutStyle ? layoutStyle : ""}`}
          style={{padding: isMobile ? '0' : '30px 0'}}
          >
            <span className="social-media">
              <img src={process.env.PUBLIC_URL + data.from} alt="Social Media" />
            </span>
            <div className="rating-container">
              {renderStars(data.rating || 0)}
            </div>
            <p className="mainparagraph" style={{fontSize: isMobile ? '20px' : '24px'}}>{data.description}</p>
            <div className="author-info">
              <div className="thumb">
                <img
                  src={process.env.PUBLIC_URL + data.authorimg}
                  alt={data.authorname}
                />
              </div>
              <div className="content">
                <span className="name">{data.authorname}</span>
                <span className="designation">{data.authordesig}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TestimonialItem;